<template>
  <div class="act_lottery_cycle" v-if="awards">


    <div class="award_cycle" :style="cycle_style">
      <img :class="['award','award'+idx]" v-for="item,idx in awards" :src="item.icon" :key='idx'
           :style="get_award_style(item.rotate)">
    </div>


    <img class="btn"  :src="lottery_btn" alt="" @click="lottery">


  </div>
</template>
<script>

  //转盘抽奖

  import Vue from 'vue'
  import click_handler from '../../../tools/mgtv/click'
  import {click_event} from '../../../tools/mgtv/analysis'

  import to_casher from '../../../tools/mgtv/casher'
  import {openLink} from '../../../tools/mgtv/link'
  import download from '../../../tools/mgtv/downapp'
  import {getJSON} from '../../../api/myaxios'
  import process_award from './process_award'
  import {process_error_action} from '../../../tools/mgtv/error_action'
  import {GET_REMAIN_TIMES} from '../../../constant/eventbus'
  import {onUseInfoLoad} from '../../../tools/onUseInfoLoad'


  const rotate_list = [
    {"rotate":-26,"ro_start":-31,"ro_end":-21},
    {"rotate":-78,"ro_start":-83,"ro_end":-73},
    {"rotate":-129,"ro_start":-134,"ro_end":-124},
    {"rotate":-180,"ro_start":-185,"ro_end":-175},
    {"rotate":-232,"ro_start":-237,"ro_end":-227},
    {"rotate":-283,"ro_start":-288,"ro_end":-278},
    {"rotate":-335,"ro_start":-340,"ro_end":-330}
    ]


  const SPEED = 10; //旋转速度，越小越快，越大越慢

  export default {
    name: "ActLotteryCycle",
    props: {
      info: {
        type: Object
      }
    },
    data() {
      return {
        awards: [],
        current: 0, //当前角度
        award_info: null
      }
    },
    computed: {
      lottery_btn() {
        if (this.info.cycle_btn) {
          return this.info.cycle_btn;
        } else {
          return 'https://vipcdn.mgtv.com/lego_admin/20190129/tmp/60e5286823a711e9a469fa163e9e1c06.png';
        }
      },
      cycle_style() {
        return {
          background: `url(${this.info.cycle_bg}) 0% 0% / cover no-repeat`,
          transform: `rotate(${-this.current}deg)`,
          webKitTransform: `rotate(${-this.current}deg)`,
        }
      },

    },
    methods: {
      get_award_style(rotate) {
        return {
          transform: `rotate(${rotate}deg)`,
          webKitTransform: `rotate(${rotate}deg)`,
        }
      },
      lottery_from_remote() {
        this.award_info = null;
        window.$toast.loading({
          mask: false,
          forbidClick: true, // 禁用背景点击
          message: '正在请求....',
          duration: 10000
        });
        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/lot", {
          act_name: window.rootdata.act_name,
          ticket: window.$bus.user.ticket
        }).then(res => {
          window.$toast.clear();
          if (!res) {
            window.$toast('请求超时，请重试');
            click_event('抽奖超时');
            return;
          }
          if (res && res.ret === 0) {
            const award_info = res.data;
            const find = this.awards.find(item => {
              return item.id === award_info.award_id;
            });
            if (find) {
              award_info.rotate = find.rotate;
              award_info.ro_start = find.ro_start;
              award_info.ro_end = find.ro_end;
              this.award_info = award_info;
              Vue.set(window.$bus.lottery, 'remain_chance', res.data.remain_chance);
              this.start_roll(); //开始转动，和九宫格不同
              click_event('抽奖成功');
            } else {
              window.$toast('抽奖失败,请重试')
              click_event('抽到一个未知的奖品');
            }
          } else {
            process_error_action(res.data.action, res.msg);
            click_event('抽奖失败_' + res.msg)
          }
        }).catch(e => {
          window.$toast.clear();
          window.$toast('抽奖失败,请重试')
          click_event('抽奖异常')
        })
      },
      fetchPrizes() {
        getJSON("//vipact3.api.mgtv.com/api/v1/act/lot/award/list", {act_name: window.rootdata.act_name}).then(res => {
          if (res && res.ret === 0) {
            if (res.data.list.length !== 7) {
              window.$toast('转盘抽奖奖品种类不足！');
              console.error('转盘抽奖奖品种类不足,请放7个');
              return;
            }

            //设置每个奖品的角度
            res.data.list.forEach((item, index) => {
              // //程序版
              // item.rotate = -Math.ceil((360 / 7 * (index + 0.5))); // 7等分，第一个奖品是 -0.5 * 360 / 7 角度，后面的每个增加一个等分角度 （中轴线，奖品图片按照这个角度旋转的）
              //
              // //取10度夹角，为这个奖品的有效范围，由于是7等分，所以互相不重叠。
              // item.ro_start = item.rotate - 5;
              // item.ro_end = item.rotate + 5;

              // //按照上面的程序生成的常数版
              item.rotate = rotate_list[index].rotate;
              item.ro_start = rotate_list[index].ro_start;
              item.ro_end = rotate_list[index].ro_end;

            });

            this.awards = res.data.list;
            console.log(this.awards);
          }
        })
      },
      stop_roll() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
        setTimeout(() => {
          process_award(this.award_info);
        }, 200);
      },
      lottery() {
        if(this.interval){
          //还在转，禁止抽奖
          return;
        }
        click_handler(this.info.name + '-抽奖按钮', this.lottery_from_remote, {
          need_login: true,
          need_act: true,
          need_new_user: false,
          need_vip_level: -1,
        });
      },
      start_roll() {
        if (this.interval) {
          return;
        }
        //start rolling
        this.current = this.current % 360;
        this.interval = setInterval(() => {
          //rolling
          this.current -= 8; //不要大于10

          //持续roll
          if (this.current > -720) {
            return;
          }
          //stop rolling

          const curr_rotate = this.current % 360;
          if(this.award_info && curr_rotate >= this.award_info.ro_start && curr_rotate <= this.award_info.ro_end) {
            this.stop_roll(); //停止转动，展示奖品
            // console.log(this.current % 360, this.award_info.rotate);
          }
        }, SPEED);
      }
    },
    created() {
      this.fetchPrizes();
      onUseInfoLoad(()=>{
        window.$bus.$emit(GET_REMAIN_TIMES);
      })
    }

  }
</script>
<style lang="stylus">

  @import "../../../share/mixins.styl"

  .act_lottery_cycle
    width 5.62rem
    height 5.62rem
    position: relative
    .btn
      position absolute
      width 2.7rem
      height 2.7rem
      center()
      z-index 20
    .award_cycle
      width 100%
      height 100%
      position relative
      .award
        width 2.2rem
        height 2.8rem
        position absolute
        z-index 1
        transform-origin 50% bottom
        top: 0;
        right: 1.71rem;


</style>





// WEBPACK FOOTER //
// src/components/ConfigUI/Lottery/ActLotteryCycle.vue